import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import CloseIcon from '@mui/icons-material/Close';
import { IconButton, Typography } from '@mui/material';
import { Box, Stack } from '@mui/system';
import { GridApiPro } from '@mui/x-data-grid-pro';

import TableInstance from '@/shared/constants/tableInstance';

import ActionButton from './ActionButton/ActionButton';
import Action from './ActionButton/types/action.type';

const tableNameConfig: { [key in TableInstance]: string } = {
  [TableInstance.Customers]: 'Customers',
  [TableInstance.Orders]: 'Orders',
  [TableInstance.Products]: 'Products',
  [TableInstance.Inventory]: 'Inventory',
  [TableInstance.Atoms]: 'Atoms',
  [TableInstance.FulfilmentProviders]: 'Fulfilment Providers',
  [TableInstance.Queues]: 'Queues',
  [TableInstance.FulfilmentOrders]: 'Fulfilment Orders',
  [TableInstance.GoogleCalendarsAccounts]: 'Google Calendars Account',
  [TableInstance.BookingsServices]: 'Booking Services',
  [TableInstance.PaymentProcessors]: 'Processors',
  [TableInstance.Payments]: 'Payments',
  [TableInstance.ShippingProviders]: 'Providers',
  [TableInstance.ShippingProfiles]: 'Profiles',
  [TableInstance.AssignProductsAndVariants]: 'Products and Variants',
  [TableInstance.ManageZones]: 'Zones',
  [TableInstance.Cities]: 'Cities',
  [TableInstance.AssignedProducts]: 'Assigned Products',
  [TableInstance.Packages]: 'Packages',
  [TableInstance.Users]: 'Users',
};

export type SnackToolbarProps = {
  apiRef: React.MutableRefObject<GridApiPro>;
  instanceId: TableInstance;
  selectedRows: number;
  actions?: Action[];
  onClose?: () => void;
};

const SnackToolbar: FC<SnackToolbarProps> = ({
  apiRef,
  instanceId,
  selectedRows,
  actions,
  onClose,
}) => {
  const { t } = useTranslation(['dataGrid']);

  return (
    <Stack direction='row' gap={2} alignItems='center'>
      <Stack direction='row' gap={0.5}>
        <Typography variant='body2' fontWeight='500'>
          {tableNameConfig[instanceId]}
        </Typography>
        <span>-</span>
        <Typography variant='body2'>
          {`${selectedRows} ${t('dataGrid:snackbarTitle', { count: selectedRows })}`}
        </Typography>
      </Stack>

      <Box sx={{ ml: 'auto', display: 'flex', alignItems: 'center', gap: 1 }}>
        {actions?.map((action, idx) => (
          <ActionButton key={idx} action={action} apiRef={apiRef} />
        ))}

        <IconButton
          size='small'
          onClick={() => {
            apiRef.current.setRowSelectionModel([]);
            onClose?.();
          }}
          color='inherit'
        >
          <CloseIcon sx={{ color: 'text.secondary', width: 20, height: 20 }} />
        </IconButton>
      </Box>
    </Stack>
  );
};

export default SnackToolbar;
